/**
 * Session-scoped iOS access grant (App Review / TestFlight testing).
 * Cleared on app kill → cold start always returns to the subscription gate
 * until the user re-enters the review code, restores Apple purchase, or buys.
 */
const IOS_ACCESS_SESSION_KEY = 'zia_ios_access_session';
/** When set, block auto StoreKit unlock until user restores / buys / enters review code. */
const IOS_FORCE_GATE_KEY = 'zia_ios_force_subscription_gate';

export function markIosAccessSessionGranted(): void {
  try {
    window.sessionStorage.setItem(IOS_ACCESS_SESSION_KEY, '1');
    window.sessionStorage.removeItem(IOS_FORCE_GATE_KEY);
  } catch {
    // Best effort — gate stays locked if storage is unavailable.
  }
}

export function hasIosAccessSessionGranted(): boolean {
  try {
    return window.sessionStorage.getItem(IOS_ACCESS_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearIosAccessSessionGranted(): void {
  try {
    window.sessionStorage.removeItem(IOS_ACCESS_SESSION_KEY);
  } catch {
    // Best effort.
  }
}

/** Settings / testing: force paywall even if StoreKit already has an entitlement. */
export function forceIosSubscriptionGate(): void {
  try {
    window.sessionStorage.removeItem(IOS_ACCESS_SESSION_KEY);
    window.sessionStorage.setItem(IOS_FORCE_GATE_KEY, '1');
  } catch {
    // Best effort.
  }
}

export function isIosSubscriptionGateForced(): boolean {
  try {
    return window.sessionStorage.getItem(IOS_FORCE_GATE_KEY) === '1';
  } catch {
    return false;
  }
}
